var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.13fc985eddd0280ef6b893b63772d353.svg#m';
                    var viewUrl = 'sprites.13fc985eddd0280ef6b893b63772d353.svg#view-m';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 31 21',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };